module.exports = __webpack_public_path__ + "static/img/banner-fabric-6.7aa2c85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/layout/banner/en/banner-fabric-6.jpg
// module id = 520
// module chunks = 63